'use client';
import { ReactNode } from 'react';
import { useGlobalBanner } from '@/context/globalBannerContext';
import classNames from 'classnames';

// To be able to utilize the hooks needed from RenderPage
export const RenderPageClientWrapper = ({
  children,
  slug,
}: {
  children: ReactNode;
  slug: string[] | string | undefined;
}) => {
  const { isBannerVisible } = useGlobalBanner();

  const isHome = !slug;
  return (
    <div
      className={classNames({
        globalBannerOffset: isBannerVisible && !isHome,
      })}
    >
      {children}
    </div>
  );
};
